/* eslint-disable @typescript-eslint/naming-convention */
export namespace DataType {
    export type SubjectiveDataType = {
        Subject: string;
    };

    export namespace User {
        export interface RequestData {
            Token: string;
            PlatformsID: number;
            WalletTypesID: number;
        }

        export interface ResponseData extends BalanceData {
            Nickname: string;
            Avatar: string;
            Denom: number;
            CurrencyRatio: number;
            AccountCurrency: string;
            LastTable?: string;
            LastRoundID?: number;
            AccountInfoURL?: string;
        }

        export interface BalanceData {
            Balance: number;
            TrialBalance: number;
            BonusBalance: number;
            DepositBalance: number;
        }

        export interface UserInfo {
            Nickname: string;
            Avatar: string;
        }
    }

    export namespace Player {}

    export namespace Hall {
        export interface TableListRequestData {
            HallID: number;
            GameID: string;
        }

        export interface TableListResponseData {
            ID: number;
            GameID: string;
            Name: string;
            Type: DataType.Enums.HallType;
            Enabled: boolean;
            TableCount: number;
            PlayingTableCount: number;
            TableSummaries: Table.SummaryData[];
        }

        export interface OverviewRequestData {}
        export interface OverviewResponseData {}

        export interface StatsRequestData {}
        export interface StatsResponseData {}

        export interface BannerData {
            Type: 'image' | 'youtube' | 'entry' | 'jackpot';
            Description: string;
            ImageURL: string;
            VideoURL: string;
            OnClick: {
                HallID?: string;
                TableID?: -1;
                GameID?: string;
                URL?: string;
            };
        }
    }

    export namespace Table {
        export interface RequestData {
            TableID: number;
        }

        export interface EnterRequestData extends RequestData {
            Trial: boolean;
        }

        export interface EnterResponseData extends SummaryData, ConfigData {}

        export interface ExitResponseData extends User.BalanceData, SubjectiveDataType {
            TableID: number;
        }

        export interface ConfigData {
            DenomConfig: ValueList;
            WarnIdleTime?: number;
            LastResult: PlayerSettleData;
        }

        export interface SummaryData {
            MathID: string;
            GameID: string;
            HallID: number;
            TableID: number;
            MaxSeatCount: number;
            Playing: boolean;
            IsTrial: boolean;
            Closed: boolean;
            ExchangeRatio: string;
        }

        export interface StreamData {
            TableID: number;
            Streams: {
                Name: string;
                URL: string;
            }[];
        }

        export interface PlayerStatusData {
            ID: number;
            Nickname: string;
            Avatar: string;
            Status: number;
            RemainingIdleTime?: number;
            Time?: number;
        }

        export interface PlayerSettleData {
            TableID: number;
            Status: number;
            TotalGameBet: number;
            TotalGameWin: number;
            Denom: number;
            TransactionID: string;
            TotalBet: number;
            TotalWin: number;
            Balance: number;
            TrialBalance: number;
        }

        export interface ValueList {
            Default: number;
            Values: number[];
        }
    }

    export namespace Bet {
        export interface RequestData {
            Bet: number;
            Debug?: DebugData;
        }
        export interface ResponseData extends SubjectiveDataType {
            Bet: number;
            Balance: number;
            TransactionID: string;
            Jackpot?: any;
        }

        export interface DebugData {}
    }

    export namespace Result {
        export interface ResultData {
            Bet: number;
            Win: number;
        }
    }

    export namespace Jackpot {
        export interface StatusRequestData {}
        export interface StatusResponseData {}
        export interface RecordRequestData {}
        export interface RecordResponseData {}
        export interface PoolData {
            ID: number;
            Level: Enums.LobbyJackpotLevel;
            Value: number;
            Priority: number;
            HitDuration: number;
            TriggerUpperLimit: number;
            GroupJackpotID: number;
        }
        export interface WinResultData {
            Level: Enums.LobbyJackpotLevel;
            Win: number;
        }
        export interface WinRecordData {}
    }

    export namespace Device {
        export interface ListResponseData {
            Data: InfoResponseData[];
        }

        export interface InfoRequestData {
            DeviceID: number;
        }

        export interface InfoResponseData {
            GameID: string;
            ID: number;
            Name: string;
            Type: string;
            ContentType: string;
            Assets: AssetInfoData;
        }

        export interface AssetInfoData {
            Logo: string;
        }

        export interface TouchData {
            X: number;
            Y: number;
        }
    }

    export namespace Enums {
        export enum PlayType {
            Crowd = 'crowd',
            Multiple = 'multiple',
            Round = 'round',
            Single = 'single',
            Stage = 'stage',
            Party = 'party',
            MiniGame = 'minigame',
        }

        export enum HallType {
            Normal = 'normal',
            Arena = 'arena',
        }

        export enum GameTag {
            New = 'new',
            Hot = 'hot',
        }

        export enum LobbyJackpotLevel {
            GRAND = 1,
            MEGA,
            MAJOR,
            MINOR,
            MINI,
            MAXI,
            LINK,
        }

        // Enum 不能像是 Interface 一樣被 extends，不然 runtime 會沒有 data，這裡使用 type 來定義 TableState
        export enum TableState {
            // common
            Waiting = 'waiting',
            Start = 'start',
            Betting = 'betting',
            Receiving = 'receiving',
            Showing = 'showing',
            Cancel = 'cancel',
            Closing = 'closing',
            // Slot
            Setup = 'setup',
            Dealing = 'dealing',
        }

        export enum ResultStatus {
            Normal = 0,
            Cancelled,
            Corrected,
        }
    }
}

export default DataType;
